import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { AppContainer } from 'react-hot-loader';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import rootSaga from './sagas';
import reducer from './ducks';
// import thunk from 'redux-thunk';
import { syncHistoryWithStore } from 'react-router-redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import createSagaMiddleware from 'redux-saga';
import ErrorBoundary from './components/ErrorBoundary';

const sagaMiddleware = createSagaMiddleware();

export const store = createStore(reducer, composeWithDevTools(
  applyMiddleware(sagaMiddleware)//thunk
));

const routerHistory = syncHistoryWithStore(browserHistory, store, { selectLocationState: state => state.get('router') });

sagaMiddleware.run(rootSaga);

class App extends Component {
  constructor() {
    super();
    if (window.Chargebee) {
      window.Chargebee.init({
        site: process.env.REACT_APP_CHARGEBEE_SITE,
        publishableKey: process.env.REACT_APP_CHARGEBEE_KEY
      });
    }
    this.state = { stripe: null };
  }


  componentDidMount() { }

  render() {
    return (
      <ErrorBoundary>
        <AppContainer errorReporter={Error}>
          <Provider store={store}>
            <this.props.Component routerHistory={routerHistory} />
          </Provider>
        </AppContainer>
      </ErrorBoundary>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js